import { Custom_Request_Bool_Exp } from "@/generated/graphql";

const getProjectCustomRequestConditions = (projectId: string): Custom_Request_Bool_Exp => ({
    _and: [
      {
        status: {
          _neq: "resolved",
        },
      },
      {
        _or: [
          {
            project_id: {
              _eq: projectId,
            },
          },
          {
            project_activity: {
              project_id: {
                _eq: projectId,
              },
              deleted: {
                _eq: false,
              }
            },
          },
        ],
      },
    ],
  }
);

export {
  getProjectCustomRequestConditions,
};